import { mkInput, mkType, SchemaToType } from '@main/schema-utils';

export const SensitiveCategory = mkType({
  name: 'SensitiveCategory',
  comment: 'A sensitive category of the organization',
  fields: {
    id: {
      comment: 'The unique ID of the sensitive category',
      modelName: 'sensitiveCategory',
      type: 'id',
    },
    title: {
      comment: 'The title of the sensitive category',
      type: 'string',
    },
    color: {
      comment: 'The color of the sensitive category',
      type: 'string',
    },
  },
});

/** Override type */
export type SensitiveCategory = SchemaToType<typeof SensitiveCategory>;

export const SensitiveCategoriesFiltersInput = mkInput({
  name: 'SensitiveCategoriesFiltersInput',
  comment: 'Filters for sensitive categories',
  fields: {
    text: {
      comment: 'Find sensitive categories by text',
      optional: true,
      type: 'string',
    },
  },
});

/** Override type */
export type SensitiveCategoriesFiltersInput = SchemaToType<
  typeof SensitiveCategoriesFiltersInput
>;
